import React from "react";
import Logo from "../../assets/images/logo.png";

const Header = () => {
  return (
    <div className="flex flex-col mb-6 text-center">
      <div className="flex justify-center items-center mb-4">
        <img
          src={Logo}
          className="w-32 h-auto drop-shadow-md transition-transform duration-300 hover:scale-105"
          alt="NUC Logo"
        />
      </div>

      <div className="space-y-3">
        <div className="inline-block px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-full shadow-sm">
          NUC ACCREDITATION MANAGEMENT
        </div>
        <h2 className="text-2xl font-bold bg-gradient-to-r from-primary-600 to-success-600 bg-clip-text text-transparent">
          REPRESENTATIVE SIGN IN
        </h2>
      </div>
    </div>
  );
};

export default Header;